module.exports = __webpack_public_path__ + "img/2.f57d033d.png";